// extracted by mini-css-extract-plugin
module.exports = {"container":"AddAddress_container__3DTuo","inputsContainer":"AddAddress_inputsContainer__34RQa"};